import React from 'react';
import { TopUrgencyBar } from './components/TopUrgencyBar';
import { Hero } from './components/Hero';
import { PainAgitation } from './components/PainAgitation';
import { WhyOtherSolutionsFail } from './components/WhyOtherSolutionsFail';
import { PromiseTransformation } from './components/PromiseTransformation';
import { ProductPresentation } from './components/ProductPresentation';
import { GuideChapters } from './components/GuideChapters';
import { PremiumBonuses } from './components/PremiumBonuses';
import { ValueStack } from './components/ValueStack';
import { PriceBox } from './components/PriceBox';
import { WhoIsItFor } from './components/WhoIsItFor';
import { SponsorEndorsement } from './components/SponsorEndorsement';
import { SponsorClosing } from './components/SponsorClosing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { MainCTA } from './components/MainCTA';
import { FAQ } from './components/FAQ';
import { EmotionalClosing } from './components/EmotionalClosing';
import { LegalDisclaimer } from './components/LegalDisclaimer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-bg-primary" data-id="element-0">
      <TopUrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SponsorEndorsement data-id="element-3" />
      <PainAgitation data-id="element-4" />
      <WhyOtherSolutionsFail data-id="element-5" />
      <PromiseTransformation data-id="element-6" />
      <ProductPresentation data-id="element-7" />
      <GuideChapters data-id="element-8" />
      <PremiumBonuses data-id="element-9" />
      <ValueStack data-id="element-10" />
      <PriceBox data-id="element-11" />
      <WhoIsItFor data-id="element-12" />
      <Testimonials data-id="element-13" />
      <Guarantee data-id="element-14" />
      <Urgency data-id="element-15" />
      <MainCTA data-id="element-16" />
      <FAQ data-id="element-17" />
      <EmotionalClosing data-id="element-18" />
      <SponsorClosing data-id="element-19" />
      <LegalDisclaimer data-id="element-20" />
      <Footer data-id="element-21" />
    </div>;
}